import {FiftyFiftyEntity} from '~/types/FiftyFiftyEntity';
import {PageSectionContainer} from '../elements/PageSectionContainer';
import {FiftyFiftyItem} from './FiftyFiftyItem.client';
import {DATA_TEST_IDS} from '~/lib/const';

export function FiftyFifty({fiftyFifty}: {fiftyFifty: FiftyFiftyEntity}) {
  return (
    <PageSectionContainer
      testid={DATA_TEST_IDS.FIFTY_FIFTY}
      className={
        'flex  flex-col lg:flex-row space-y-5 lg:space-y-0 lg:space-x-[38px]'
      }
    >
      {fiftyFifty.heroArray.map((hero) => (
        <FiftyFiftyItem key={hero.name} fiftyFifty={hero.fiftyFifty} />
      ))}
    </PageSectionContainer>
  );
}
